/**
 * @param {object} object - The object to filter.
 * remove empty values from object
 * @returns {object} - The filtered object.
 */
export const filterObject = (object) => {
  return Object.fromEntries(
    Object.entries(object).filter(([key, value]) => {
      if (Array.isArray(value)) {
        return value.length > 0
      }

      return value != null
    })
  )
}
